import { default as Container } from './Container';

export default Container;
